import { useCallback, useMemo } from 'react';
import { useCompareMode, useConversationActions } from 'src/hooks';

export const useDeleteComparingConversations = () => {
  const { resetCompareMode } = useCompareMode();
  const { deleteConversationById, isDeleteLoading } = useConversationActions();

  const deleteComparingConversations = useCallback(
    async ({
      curentConvId,
      linkedConvId,
    }: {
      curentConvId: string;
      linkedConvId: string;
    }) => {
      await deleteConversationById({
        conversation_id: curentConvId,
      });
      await deleteConversationById({
        conversation_id: linkedConvId,
      });

      resetCompareMode();
    },
    [deleteConversationById, resetCompareMode],
  );

  return useMemo(
    () => ({
      deleteComparingConversations,
      isDeleteLoading,
    }),
    [deleteComparingConversations, isDeleteLoading],
  );
};
